// src/components/ModalResponsavelPilha.jsx
import React, { useState } from "react";
import { FaTimes, FaUserMinus } from "react-icons/fa";
import "./ModalResponsavelPilha.css";

/**
 * Modal para designar/remover responsável de uma pilha.
 *
 * Props:
 *   pilha        — objeto da pilha { id, title, responsavel_id }
 *   membros      — array de { id, nickname, avatar_url }
 *   usuarioId    — id do usuário logado (para controle de permissão no futuro)
 *   onSave(userId | null) — callback com o novo responsavel_id (null = remover)
 *   onClose()    — fecha o modal
 */
export default function ModalResponsavelPilha({
  pilha,
  membros,
  usuarioId,
  onSave,
  onClose,
}) {
  const [selecionado, setSelecionado] = useState(pilha?.responsavel_id || null);
  const [salvando, setSalvando] = useState(false);

  const handleSave = async () => {
    setSalvando(true);
    await onSave(selecionado);
    setSalvando(false);
    onClose();
  };

  const handleRemover = async () => {
    setSalvando(true);
    await onSave(null);
    setSalvando(false);
    onClose();
  };

  return (
    <div className="mrp-overlay" onClick={onClose}>
      <div className="mrp-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="mrp-header">
          <div className="mrp-header-left">
            <span className="material-symbols-outlined mrp-header-icon">person_pin_circle</span>
            <div>
              <h3 className="mrp-title">Responsável da Pilha</h3>
              <p className="mrp-subtitle">{pilha?.title}</p>
            </div>
          </div>
          <button className="mrp-close" onClick={onClose} title="Fechar">
            <FaTimes />
          </button>
        </div>

        {/* Lista de membros */}
        <div className="mrp-body">
          {membros.length === 0 ? (
            <p className="mrp-empty">Nenhum membro encontrado neste projeto.</p>
          ) : (
            <ul className="mrp-members-list">
              {membros.map((m) => {
                const isSelected = selecionado === m.id;
                return (
                  <li
                    key={m.id}
                    className={`mrp-member-item ${isSelected ? "mrp-member-item--selected" : ""}`}
                    onClick={() => setSelecionado(isSelected ? null : m.id)}
                  >
                    <div className="mrp-member-avatar-wrap">
                      {m.avatar_url ? (
                        <img
                          src={m.avatar_url}
                          alt={m.nickname || "Membro"}
                          className="mrp-member-avatar"
                        />
                      ) : (
                        <div className="mrp-member-avatar mrp-member-avatar--fallback">
                          {(m.nickname || "?")[0].toUpperCase()}
                        </div>
                      )}
                      {isSelected && (
                        <span className="mrp-member-check material-symbols-outlined">
                          check_circle
                        </span>
                      )}
                    </div>
                    <span className="mrp-member-name">{m.nickname || "Sem nome"}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        {/* Footer */}
        <div className="mrp-footer">
          {pilha?.responsavel_id && (
            <button
              className="mrp-btn mrp-btn--remove"
              onClick={handleRemover}
              disabled={salvando}
            >
              <FaUserMinus size={13} />
              Remover responsável
            </button>
          )}
          <div className="mrp-footer-right">
            <button className="mrp-btn mrp-btn--cancel" onClick={onClose} disabled={salvando}>
              Cancelar
            </button>
            <button
              className="mrp-btn mrp-btn--save"
              onClick={handleSave}
              disabled={salvando || !selecionado}
            >
              {salvando ? "Salvando…" : "Confirmar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}